module.exports = __webpack_public_path__ + "static/sicyt@2x-93a89023e7bd1a7e010c0178fed6c614.png";